import { render, staticRenderFns } from "./ListItemStickerComponent.vue?vue&type=template&id=2895701a&"
import script from "./ListItemStickerComponent.vue?vue&type=script&lang=js&"
export * from "./ListItemStickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListItemStickerComponent.vue?vue&type=style&index=0&id=2895701a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports